import React from 'react';

export const FilterButtons = ({ filters, onFilter }) => {
  return (
    <div className="filter-buttons">
      {filters.map(({ label, value }) => (
        <button
          key={value}
          onClick={() => onFilter(value)}
          className="filter-button"
        >
          {label}
        </button>
      ))}
    </div>
  );
};
